var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiLoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FF9171",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11510_431)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11510_431",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12H44.5V44H12.5V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11510_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 12.625C20.0013 12.625 13.125 19.5025 13.125 28C13.125 36.4987 20.0025 43.375 28.5 43.375C36.9988 43.375 43.875 36.4975 43.875 28C43.875 19.6704 37.1257 12.625 28.5 12.625Z",
    fill: "#FF9171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 12.625C20.0012 12.625 13.125 19.5025 13.125 28C13.125 36.4988 20.0025 43.375 28.5 43.375C36.9988 43.375 43.875 36.4975 43.875 28C43.875 19.6704 37.1257 12.625 28.5 12.625Z",
    fill: "#FF9171"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5001 42.7498C20.3478 42.7498 13.7502 36.1534 13.7502 27.9999C13.7502 19.8476 20.3466 13.25 28.5001 13.25C36.7727 13.25 43.25 20.0077 43.25 27.9999C43.25 36.1522 36.6536 42.7498 28.5001 42.7498ZM12.5 27.9999C12.5 36.8439 19.6574 44 28.5001 44C37.3441 44 44.5002 36.8426 44.5002 27.9999C44.5002 19.3329 37.4788 11.9998 28.5001 11.9998C19.6561 11.9998 12.5 19.1572 12.5 27.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 12.625V16.375H43.875L40.125 20.125H36.375V16.375L40.125 12.625Z",
    fill: "#DCEF6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 28C38.25 33.3762 33.8762 37.75 28.5 37.75C23.1238 37.75 18.75 33.3762 18.75 28C18.75 22.6238 23.1238 18.25 28.5 18.25C33.8761 18.25 38.25 22.6236 38.25 28Z",
    fill: "#EEFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.625 28C32.625 30.2744 30.7744 32.125 28.5 32.125C26.2256 32.125 24.375 30.2744 24.375 28C24.375 25.7256 26.2256 23.875 28.5 23.875C30.7749 23.875 32.625 25.7249 32.625 28Z",
    fill: "#FF9171"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.75 20.125C35.75 20.4702 36.0298 20.75 36.375 20.75H40.125C40.2908 20.75 40.4497 20.6842 40.5669 20.5669L44.3169 16.8169C44.4957 16.6382 44.5492 16.3694 44.4524 16.1358C44.3557 15.9023 44.1278 15.75 43.875 15.75H40.75V12.625C40.75 12.3722 40.5977 12.1443 40.3642 12.0476C40.1306 11.9508 39.8618 12.0043 39.6831 12.1831L35.9331 15.9331C35.8158 16.0503 35.75 16.2092 35.75 16.375V20.125ZM37 19.5V16.6339L39.5 14.1339V16.375C39.5 16.7202 39.7798 17 40.125 17H42.3661L39.8661 19.5H37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0581 28.4419C28.3021 28.686 28.6979 28.686 28.9419 28.4419L36.8169 20.5669C37.061 20.3229 37.061 19.9271 36.8169 19.6831C36.5729 19.439 36.1771 19.439 35.9331 19.6831L28.0581 27.5581C27.814 27.8021 27.814 28.1979 28.0581 28.4419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 28C18.125 33.7214 22.7786 38.375 28.5 38.375C34.2214 38.375 38.875 33.7214 38.875 28C38.875 25.1389 37.7102 22.5445 35.8333 20.6669L35.8331 20.6667C33.9555 18.7898 31.3611 17.625 28.5 17.625C22.7786 17.625 18.125 22.2786 18.125 28ZM28.5 37.125C23.4689 37.125 19.375 33.0311 19.375 28C19.375 22.9689 23.4689 18.875 28.5 18.875C31.015 18.875 33.2956 19.8976 34.9492 21.5506C34.9493 21.5506 34.9493 21.5507 34.9493 21.5507C34.9493 21.5507 34.9494 21.5507 34.9494 21.5508C36.6024 23.2044 37.625 25.485 37.625 28C37.625 33.0311 33.5311 37.125 28.5 37.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 28C23.75 30.6196 25.8804 32.75 28.5 32.75C31.1196 32.75 33.25 30.6196 33.25 28C33.25 26.6896 32.7165 25.5014 31.8576 24.6424C30.9986 23.7835 29.8104 23.25 28.5 23.25C25.8804 23.25 23.75 25.3804 23.75 28ZM28.5 31.5C26.5708 31.5 25 29.9292 25 28C25 26.0708 26.5708 24.5 28.5 24.5C29.4646 24.5 30.3389 24.8915 30.9737 25.5263C31.6085 26.1611 32 27.0354 32 28C32 29.9292 30.4292 31.5 28.5 31.5Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11510_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiLoIcon);
export default __webpack_public_path__ + "static/media/li_lo_icon.32c7cfa9f2f780fbff851beb259d767c.svg";
export { ForwardRef as ReactComponent };